import { useMemo } from 'react'

import { Embroidery } from '../../../../../types/graphql'

export type UseProductPageEmbroiderySettingsOpts = {
  embroidery: Embroidery[] | null
  mandatoryLogoEmbroidery?: boolean
  isPortalColorSelected?: boolean
}
/**
 * Derive the embroidery settings based on the current product & user characteristics.
 */
export function useProductPageEmbroiderySettings({
  embroidery,
  isPortalColorSelected,
}: UseProductPageEmbroiderySettingsOpts) {
  // Whether or not the current product supports logo + text embroidery for portals
  const hasLogoOnlyEmbroidery = useMemo(() => {
    return embroidery?.some(({ kind }) => kind === 'LOGO_ONLY')
  }, [embroidery])

  // Derive embroidery options that should be present for the current product
  const embroideryOptions: ReadonlyArray<Embroidery> = useMemo(() => {
    const defaultOptions = embroidery ?? []
    // Use portal-specific embroidery options if applicable portal color is selected
    if (isPortalColorSelected && hasLogoOnlyEmbroidery)
      return defaultOptions.filter(opt =>
        ['TEXT_ONLY', 'LOGO_ONLY', 'LOGO_TEXT'].includes(opt.kind)
      )

    return defaultOptions.filter(option => !['LOGO_ONLY', 'LOGO_TEXT'].includes(option.kind))
  }, [embroidery, isPortalColorSelected, hasLogoOnlyEmbroidery])

  return {
    embroideryOptions,
  }
}
